'use client';

import { motion } from 'framer-motion';
import type { StatsSectionProps } from '@routeroyal/theme-core';

/**
 * Stone Investment Stats Section
 * 
 * Sophisticated statistics display with:
 * - Large typography
 * - Minimal borders
 * - Elegant spacing
 */
export function StoneInvestmentStatsSection({ stats }: StatsSectionProps) {
  if (!stats || stats.length === 0) {
    return null;
  }

  return (
    <section className="py-20 lg:py-28 bg-[var(--color-surface)] border-y border-[var(--color-border)]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center lg:text-left"
            >
              <p 
                className="text-4xl lg:text-5xl xl:text-6xl text-[var(--color-text)] mb-3"
                style={{ 
                  fontFamily: "'Cormorant Garamond', 'Georgia', serif",
                  fontWeight: 300,
                }}
              >
                {stat.value}
              </p>
              <p 
                className="text-xs tracking-[0.2em] uppercase text-[var(--color-text-muted)]"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
